export default "__VITE_ASSET__CoIuEwqF__"